module.exports = "/images/acquire-new-customers.svg?aac9d1c69b98bee05c0e5ad8cab22c9a";